<template>
  <div>
    <div class="margin-right-left padding-top">
      <Row type="flex" :space-x="10">
        <Cell>
          <Button icon="fa fa-arrow-left" @click="$router.push({name:'Tripartite'})">返回</Button>
          <span style="font-size: 16px; font-weight: bold; margin-left: 10px;">{{ definition.name }}</span>
          <span class="gray-color" style="margin-left: 8px;">{{ definition.code }}</span>
        </Cell>
        <Cell flex>
          <div class="text-right">
            <Button color="primary" icon="fa fa-plus" @click="addRecord">新增</Button>
            <Button icon="fa fa-upload" @click="showImport=true">导入</Button>
            <Button icon="fa fa-download" @click="exportSelected" :disabled="!checkedList.length">导出选中</Button>
            <Button icon="fa fa-download" @click="exportAll">导出全部</Button>
            <Button color="red" icon="fa fa-trash" @click="batchRemove" :disabled="!checkedList.length">批量删除</Button>
            <Button color="green" icon="fa fa-magic" @click="openGenerate" :disabled="!checkedList.length">生成凭证</Button>
            <Button color="blue" icon="fa fa-cog" @click="openTemplates">模板设置</Button>
          </div>
        </Cell>
      </Row>
      <!--检索区-->
      <Row type="flex" :space-x="10" style="margin-top: 10px;">
        <Cell v-for="f in dataFields" :key="f.fieldName" v-width="f.fieldType==='NUMBER'?220:160">
          <div v-if="f.fieldType==='NUMBER'" class="h-input-group">
            <input type="number" v-model="filterValues[f.fieldName].min" :placeholder="f.displayName+'(最小)'" style="width:110px">
            <span class="h-input-addon">至</span>
            <input type="number" v-model="filterValues[f.fieldName].max" :placeholder="f.displayName+'(最大)'" style="width:110px">
          </div>
          <input v-else type="text" v-model="filterValues[f.fieldName]" :placeholder="f.displayName">
        </Cell>
        <Cell v-width="150">
          <Select v-model="voucherStatus" :datas="[{key:'',title:'全部记录'},{key:'generated',title:'已生成凭证'},{key:'ungenerated',title:'未生成凭证'}]"
                  keyName="key" titleName="title" :deletable="false"></Select>
        </Cell>
        <Cell>
          <Button color="primary" icon="fa fa-search" @click="doSearch">查询</Button>
          <Button @click="resetSearch">重置</Button>
        </Cell>
      </Row>
    </div>

    <div class="h-panel-body padding-top">
      <Table :datas="datas" :loading="loading" :border="true">
        <TableItem :width="40" align="center">
          <div slot-scope="{data}">
            <input type="checkbox" v-model="data._checked" :disabled="!!data.voucherId">
          </div>
        </TableItem>
        <TableItem v-for="f in dataFields" :key="f.fieldName" :title="f.displayName" :width="f.fieldType==='NUMBER'?120:140"
                   :align="f.fieldType==='NUMBER'?'right':'left'">
          <template slot-scope="{data}">{{ formatCell(data.data[f.fieldName], f) }}</template>
        </TableItem>
        <TableItem title="凭证状态" :width="100" align="center">
          <template slot-scope="{data}">
            <span class="h-tag h-tag-bg-blue pointer" v-if="data.voucherId" @click="openVoucher(data)">已生成</span>
            <span class="h-tag h-tag-bg-gray" v-else>未生成</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="110">
          <div class="actions" slot-scope="{data}">
            <span @click="editRecord(data)" v-if="!data.voucherId">编辑</span>
            <span class="red-color" @click="removeRecord(data)" v-if="!data.voucherId">删除</span>
          </div>
        </TableItem>
        <div slot="empty">暂无数据，点击"新增"或"导入"添加数据</div>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" @change="loadList" layout="total,sizes,pager,jumper" small align="right"/>
    </div>

    <!--新增/编辑数据-->
    <Modal v-model="showRecordForm" hasCloseIcon>
      <div slot="header">{{ recordForm.id ? '编辑数据' : '新增数据' }}</div>
      <Form ref="recordForm" v-width="400" :labelWidth="110" :model="recordForm">
        <FormItem v-for="f in dataFields" :key="f.fieldName" :label="f.displayName" :required="!!f.required">
          <DatePicker v-if="f.fieldType==='DATE'" type="date" v-model="recordForm[f.fieldName]" format="YYYY-MM-DD"></DatePicker>
          <NumberInput v-else-if="f.fieldType==='NUMBER'" v-model="recordForm[f.fieldName]"></NumberInput>
          <input v-else type="text" v-model="recordForm[f.fieldName]">
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="saveRecord" :loading="saving">{{ recordForm.id ? '更新' : '保存' }}</Button>
        <Button @click="showRecordForm=false">取消</Button>
      </div>
    </Modal>

    <!--导入-->
    <Modal v-model="showImport" hasCloseIcon>
      <div slot="header">导入数据</div>
      <div v-width="400" style="padding: 10px 0;">
        <p>第一步：下载导入模板</p>
        <p style="margin: 10px 0 20px;">
          <Button color="primary" icon="fa fa-download" @click="downloadTemplate">下载模板</Button>
        </p>
        <p>第二步：按模板格式填写后，选取文件上传</p>
        <p style="margin: 10px 0;">
          <Button color="green" icon="fa fa-file-excel-o" @click="$refs.importFile.click()">选取文件</Button>
          <input type="file" ref="importFile" style="display:none" accept=".xlsx,.xls" @change="importFileChange">
        </p>
        <p class="gray-color" v-if="importResult">
          成功导入 {{ importResult.successCount }} 条
          <span v-if="importResult.failedList && importResult.failedList.length" class="red-color">
            ，失败 {{ importResult.failedList.length }} 条
          </span>
        </p>
        <ul v-if="importResult && importResult.failedList && importResult.failedList.length" class="red-color" style="max-height: 150px; overflow:auto;">
          <li v-for="(msg, i) in importResult.failedList" :key="i">{{ msg }}</li>
        </ul>
      </div>
      <div class="text-center">
        <Button @click="showImport=false">关闭</Button>
      </div>
    </Modal>

    <!--模板设置-->
    <Modal v-model="showTemplates" type="drawer-right" hasCloseIcon :closeOnMask="false">
      <div slot="header">凭证模板设置</div>
      <div v-width="760">
        <div style="margin-bottom: 10px;">
          <Button size="small" color="primary" icon="fa fa-plus" @click="tplAdd">新建模板</Button>
        </div>
        <Table :datas="templates" :border="true" size="small">
          <TableItem title="凭证字" prop="voucherWord" :width="70" align="center"></TableItem>
          <TableItem title="凭证日期" :width="110">
            <template slot-scope="{data}">{{ fieldDisplay(data.dateFieldName) }}</template>
          </TableItem>
          <TableItem title="凭证摘要">
            <template slot-scope="{data}">{{ (data.summaryFieldNames||[]).map(fieldDisplay).join(' ') }}</template>
          </TableItem>
          <TableItem title="匹配规则" :width="160">
            <template slot-scope="{data}">
              <span v-if="!(data.rules||[]).length" class="gray-color">全部匹配</span>
              <span v-else>{{ rulesText(data.rules) }}</span>
            </template>
          </TableItem>
          <TableItem title="分录数" :width="70" align="center">
            <template slot-scope="{data}">{{ (data.items||[]).length }}</template>
          </TableItem>
          <TableItem title="操作" :width="150">
            <div class="actions" slot-scope="{data}">
              <span @click="tplEdit(data)">编辑</span>
              <span @click="tplCopy(data)">复制</span>
              <span class="red-color" @click="tplDelete(data)">删除</span>
            </div>
          </TableItem>
          <div slot="empty">暂无模板，点击"新建模板"</div>
        </Table>
      </div>
    </Modal>

    <!--模板编辑-->
    <Modal v-model="showTplForm" type="drawer-right" hasCloseIcon :closeOnMask="false">
      <div slot="header">{{ tplForm.tid ? '编辑模板' : '新建模板' }}</div>
      <div v-width="860" style="padding-bottom: 20px;">
        <Form :labelWidth="90" :model="tplForm">
          <FormItem label="凭证字" required>
            <Select v-model="tplForm.voucherWord" :datas="voucherWords" keyName="word" titleName="word" :deletable="false" style="width:120px"></Select>
          </FormItem>
          <FormItem label="凭证日期" required>
            <Select v-model="tplForm.dateFieldName" :datas="dataFields" keyName="fieldName" titleName="displayName" placeholder="选择日期列" style="width:180px"></Select>
          </FormItem>
          <FormItem label="凭证摘要">
            <Select v-model="tplForm.summaryFieldNames" :datas="dataFields" keyName="fieldName" titleName="displayName" :multiple="true" placeholder="选择摘要列（可多个拼接）" style="width:360px"></Select>
          </FormItem>
          <FormItem label="匹配规则">
            <div class="tpl-block">
              <table class="tpl-table">
                <thead>
                <tr>
                  <th style="width:70px">逻辑</th>
                  <th style="width:140px">匹配列</th>
                  <th>匹配值（多个值用逗号分隔）</th>
                  <th style="width:36px"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(rule, i) in tplForm.rules" :key="i">
                  <td>
                    <select v-if="i>0" v-model="rule.logical" class="tpl-select">
                      <option value="AND">并且</option>
                      <option value="OR">或者</option>
                    </select>
                    <span v-else class="gray-color">-</span>
                  </td>
                  <td>
                    <select v-model="rule.fieldName" class="tpl-select">
                      <option v-for="f in dataFields" :key="f.fieldName" :value="f.fieldName">{{ f.displayName }}</option>
                    </select>
                  </td>
                  <td><input type="text" v-model="rule.matchValuesText" placeholder="留空表示匹配全部"></td>
                  <td align="center"><span class="red-color pointer" @click="tplForm.rules.splice(i,1)"><i class="fa fa-trash"></i></span></td>
                </tr>
                </tbody>
              </table>
              <Button size="small" icon="fa fa-plus" @click="tplForm.rules.push({logical:'AND',fieldName:dataFields.length?dataFields[0].fieldName:'',matchValuesText:''})">添加规则</Button>
            </div>
          </FormItem>
          <FormItem label="分录规则">
            <div class="tpl-block">
              <table class="tpl-table">
                <thead>
                <tr>
                  <th style="width:90px">项目类型</th>
                  <th style="width:110px">匹配列</th>
                  <th style="width:130px">匹配值</th>
                  <th style="width:160px">科目</th>
                  <th style="width:50px">方向</th>
                  <th style="width:60px">自动平衡</th>
                  <th style="width:110px">金额字段</th>
                  <th style="width:70px">比例%</th>
                  <th style="width:100px">数量字段</th>
                  <th style="width:100px">辅助核算</th>
                  <th style="width:36px"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tplForm.items" :key="i">
                  <td>
                    <select v-model="item.itemType" class="tpl-select">
                      <option value="DATA_SUBJECT">数据科目</option>
                      <option value="FINANCIAL_SUBJECT">记账科目</option>
                    </select>
                  </td>
                  <td>
                    <select v-if="item.itemType==='DATA_SUBJECT'" v-model="item.fieldName" class="tpl-select">
                      <option v-for="f in dataFields" :key="f.fieldName" :value="f.fieldName">{{ f.displayName }}</option>
                    </select>
                    <span v-else class="gray-color">-</span>
                  </td>
                  <td>
                    <input v-if="item.itemType==='DATA_SUBJECT'" type="text" v-model="item.matchValuesText" placeholder="逗号分隔">
                    <span v-else class="gray-color">-</span>
                  </td>
                  <td>
                    <select v-model="item.subjectId" class="tpl-select">
                      <option :value="null">请选择</option>
                      <option v-for="s in subjects" :key="s.id" :value="s.id">{{ s.code }}-{{ s.name }}</option>
                    </select>
                  </td>
                  <td>
                    <select v-model="item.direction" class="tpl-select">
                      <option value="借">借</option>
                      <option value="贷">贷</option>
                    </select>
                  </td>
                  <td align="center"><input type="checkbox" v-model="item.autoEqual"></td>
                  <td>
                    <select v-if="!item.autoEqual" v-model="item.amountFieldName" class="tpl-select">
                      <option v-for="f in numberFields" :key="f.fieldName" :value="f.fieldName">{{ f.displayName }}</option>
                    </select>
                    <span v-else class="gray-color">差额</span>
                  </td>
                  <td>
                    <input v-if="!item.autoEqual" type="number" v-model.number="item.amountRatio" min="0" max="100">
                    <span v-else class="gray-color">-</span>
                  </td>
                  <td>
                    <select v-model="item.quantityFieldName" class="tpl-select">
                      <option :value="null">无</option>
                      <option v-for="f in numberFields" :key="f.fieldName" :value="f.fieldName">{{ f.displayName }}</option>
                    </select>
                  </td>
                  <td>
                    <span class="pointer blue-color" @click="editAuxMappings(item)">
                      {{ (item.auxiliaryFieldMappings||[]).length ? '已配置(' + item.auxiliaryFieldMappings.length + ')' : '配置' }}
                    </span>
                  </td>
                  <td align="center"><span class="red-color pointer" @click="tplForm.items.splice(i,1)"><i class="fa fa-trash"></i></span></td>
                </tr>
                </tbody>
              </table>
              <Button size="small" icon="fa fa-plus" @click="addTplItem">添加分录</Button>
            </div>
          </FormItem>
        </Form>
        <div class="text-center" style="margin-top: 10px;">
          <Button color="green" @click="tplSave" :loading="saving">保存模板</Button>
          <Button @click="showTplForm=false">取消</Button>
        </div>
      </div>
    </Modal>

    <!--辅助核算映射-->
    <Modal v-model="showAuxMapping" hasCloseIcon>
      <div slot="header">辅助核算映射</div>
      <div v-width="460">
        <table class="tpl-table" style="margin-bottom: 8px;">
          <thead>
          <tr>
            <th style="width:180px">辅助核算类别</th>
            <th>业务列</th>
            <th style="width:36px"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(m, i) in auxMappings" :key="i">
            <td>
              <select v-model="m.categoryTypeId" class="tpl-select">
                <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
              </select>
            </td>
            <td>
              <select v-model="m.fieldName" class="tpl-select">
                <option v-for="f in dataFields" :key="f.fieldName" :value="f.fieldName">{{ f.displayName }}</option>
              </select>
            </td>
            <td align="center"><span class="red-color pointer" @click="auxMappings.splice(i,1)"><i class="fa fa-trash"></i></span></td>
          </tr>
          </tbody>
        </table>
        <Button size="small" icon="fa fa-plus" @click="auxMappings.push({categoryTypeId: categories.length?categories[0].id:null, fieldName: dataFields.length?dataFields[0].fieldName:''})">添加映射</Button>
      </div>
      <div class="text-center">
        <Button color="green" @click="saveAuxMappings">确定</Button>
        <Button @click="showAuxMapping=false">取消</Button>
      </div>
    </Modal>

    <!--生成凭证预览-->
    <Modal v-model="showGenerate" type="drawer-right" hasCloseIcon :closeOnMask="false">
      <div slot="header">生成凭证预览</div>
      <div v-width="980" style="padding-bottom: 20px;">
        <Row type="flex" :space-x="15" style="margin-bottom: 10px;">
          <Cell>
            <span style="line-height: 30px;">合并分录：</span>
            <HSwitch v-model="genOptions.merge" :small="true"></HSwitch>
          </Cell>
          <Cell v-if="genOptions.merge">
            <Select v-model="genOptions.mergeTypes" :datas="[{key:'mergeDebit',title:'合并借方'},{key:'mergeCredit',title:'合并贷方'}]"
                    keyName="key" titleName="title" :multiple="true" style="width:200px"></Select>
          </Cell>
          <Cell>
            <span style="line-height: 30px;">凭证日期：</span>
            <DatePicker type="date" v-model="genOptions.voucherDate" format="YYYY-MM-DD" style="width:140px" placeholder="默认取记录日期"></DatePicker>
          </Cell>
          <Cell>
            <span style="line-height: 30px;">凭证字：</span>
            <Select v-model="genOptions.voucherWord" :datas="voucherWords" keyName="word" titleName="word" style="width:100px" placeholder="默认模板"></Select>
          </Cell>
        </Row>
        <div v-for="pv in previewVouchers" :key="pv.key" class="preview-voucher" :class="{'preview-error': pv.error}">
          <div class="preview-head">
            <span class="h-tag h-tag-bg-primary">{{ pv.recordLabel }}</span>
            <span style="margin-left: 10px;">{{ pv.voucher.voucherDate }} {{ pv.voucher.word }}</span>
            <span class="red-color" style="margin-left: 10px;" v-if="pv.error">{{ pv.error }}</span>
          </div>
          <table class="tpl-table" v-if="!pv.error">
            <thead>
            <tr>
              <th>摘要</th>
              <th style="width:200px">科目</th>
              <th style="width:110px">借方金额</th>
              <th style="width:110px">贷方金额</th>
              <th style="width:80px">数量</th>
              <th style="width:90px">单价</th>
              <th>辅助核算</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d, di) in pv.voucher.details" :key="di">
              <td><input type="text" v-model="d.summary"></td>
              <td>
                <select v-model="d.subjectId" class="tpl-select">
                  <option v-for="s in subjects" :key="s.id" :value="s.id">{{ s.code }}-{{ s.name }}</option>
                </select>
              </td>
              <td><input type="number" v-model.number="d.debitAmount" style="text-align:right"></td>
              <td><input type="number" v-model.number="d.creditAmount" style="text-align:right"></td>
              <td><input type="number" v-model.number="d.num" style="text-align:right"></td>
              <td><input type="number" v-model.number="d.price" style="text-align:right"></td>
              <td>{{ d.auxiliaryTitle || '' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" style="margin-top: 10px;">
          <Button color="green" @click="submitGenerate" :loading="generating">确认生成</Button>
          <Button @click="showGenerate=false">取消</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TripartiteData',
  props: ['definitionId'],
  data() {
    return {
      definition: {},
      dataFields: [],
      filterValues: {},
      voucherStatus: '',
      datas: [],
      loading: false,
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      showRecordForm: false,
      recordForm: {},
      saving: false,
      showImport: false,
      importResult: null,
      showTemplates: false,
      templates: [],
      showTplForm: false,
      tplForm: this.emptyTplForm(),
      subjects: [],
      voucherWords: [],
      categories: [],
      showAuxMapping: false,
      auxMappings: [],
      auxMappingItem: null,
      categoryDetailsCache: {},
      showGenerate: false,
      genOptions: {
        merge: false,
        mergeTypes: ['mergeDebit', 'mergeCredit'],
        voucherDate: null,
        voucherWord: null
      },
      previewVouchers: [],
      generating: false
    }
  },
  computed: {
    checkedList() {
      return this.datas.filter(d => d._checked && !d.voucherId);
    },
    numberFields() {
      return this.dataFields.filter(f => f.fieldType === 'NUMBER');
    }
  },
  methods: {
    emptyTplForm() {
      return {
        tid: null,
        voucherWord: '记',
        dateFieldName: null,
        summaryFieldNames: [],
        rules: [],
        items: [
          {itemType: 'DATA_SUBJECT', fieldName: null, matchValuesText: '', amountFieldName: null, amountRatio: 100, subjectId: null, autoEqual: false, direction: '借', quantityFieldName: null, unitFieldName: null, auxiliaryFieldMappings: []},
          {itemType: 'FINANCIAL_SUBJECT', fieldName: null, matchValuesText: '', amountFieldName: null, amountRatio: 100, subjectId: null, autoEqual: true, direction: '贷', quantityFieldName: null, unitFieldName: null, auxiliaryFieldMappings: []}
        ]
      };
    },
    fieldDisplay(fieldName) {
      let f = this.dataFields.find(v => v.fieldName === fieldName);
      return f ? f.displayName : (fieldName || '');
    },
    rulesText(rules) {
      return (rules || []).map((r, i) => {
        let prefix = i > 0 ? (r.logical === 'OR' ? ' 或 ' : ' 且 ') : '';
        return prefix + this.fieldDisplay(r.fieldName) + '∈[' + (r.matchValues || []).join(',') + ']';
      }).join('');
    },
    formatCell(value, field) {
      if (value === null || value === undefined) {
        return '';
      }
      if (field.fieldType === 'NUMBER' && value !== '') {
        let num = Number(value);
        return isNaN(num) ? value : num.toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      }
      return value;
    },
    loadDefinition() {
      return this.$api.tripartite.definition.load(this.definitionId).then(({data}) => {
        this.definition = data || {};
        this.dataFields = data.dataFields || [];
        let filterValues = {};
        this.dataFields.forEach(f => {
          filterValues[f.fieldName] = f.fieldType === 'NUMBER' ? {min: '', max: ''} : '';
        });
        this.filterValues = filterValues;
      });
    },
    buildFilters() {
      let filters = {};
      this.dataFields.forEach(f => {
        let v = this.filterValues[f.fieldName];
        if (f.fieldType === 'NUMBER') {
          if ((v.min !== '' && v.min !== null) || (v.max !== '' && v.max !== null)) {
            filters[f.fieldName] = {min: v.min, max: v.max};
          }
        } else if (v !== '' && v !== null && v !== undefined) {
          filters[f.fieldName] = v;
        }
      });
      if (this.voucherStatus) {
        filters.voucherStatus = this.voucherStatus;
      }
      return filters;
    },
    loadList() {
      this.loading = true;
      this.$api.tripartite.data.page(this.definitionId, {page: this.pagination.page, size: this.pagination.size}, this.buildFilters()).then(({data}) => {
        let page = data.page || {};
        this.datas = (page.records || []).map(r => Object.assign({_checked: false}, r));
        this.pagination.total = page.total || 0;
        if (data.dataFields) {
          this.dataFields = data.dataFields;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    resetSearch() {
      this.dataFields.forEach(f => {
        this.filterValues[f.fieldName] = f.fieldType === 'NUMBER' ? {min: '', max: ''} : '';
      });
      this.voucherStatus = '';
      this.pagination.page = 1;
      this.loadList();
    },
    addRecord() {
      let form = {id: null};
      this.dataFields.forEach(f => {
        form[f.fieldName] = f.fieldType === 'DATE' ? moment().format('YYYY-MM-DD') : null;
      });
      this.recordForm = form;
      this.showRecordForm = true;
    },
    editRecord(data) {
      let form = {id: data.id};
      this.dataFields.forEach(f => {
        form[f.fieldName] = data.data ? data.data[f.fieldName] : null;
      });
      this.recordForm = form;
      this.showRecordForm = true;
    },
    saveRecord() {
      for (let f of this.dataFields) {
        if (f.required) {
          let v = this.recordForm[f.fieldName];
          if (v === null || v === undefined || v === '') {
            this.$Message.error(`【${f.displayName}】为必填项`);
            return;
          }
        }
      }
      this.saving = true;
      let params = Object.assign({}, this.recordForm);
      this.dataFields.forEach(f => {
        if (f.fieldType === 'DATE' && params[f.fieldName]) {
          params[f.fieldName] = moment(params[f.fieldName]).format('YYYY-MM-DD');
        }
      });
      this.$api.tripartite.data.save(this.definitionId, params).then(() => {
        this.$Message('保存成功~');
        this.showRecordForm = false;
        this.loadList();
      }).finally(() => {
        this.saving = false;
      });
    },
    removeRecord(data) {
      this.$Confirm('确认删除该条数据？').then(() => {
        this.$api.tripartite.data.delete(this.definitionId, data.id).then(() => {
          this.$Message('删除成功~');
          this.loadList();
        });
      });
    },
    batchRemove() {
      let ids = this.checkedList.map(d => d.id);
      if (!ids.length) {
        this.$Message.error('请勾选未生成凭证的记录！');
        return;
      }
      this.$Confirm(`确认删除选中的 ${ids.length} 条记录？`).then(() => {
        this.$api.tripartite.data.batchDelete(this.definitionId, ids).then(({data}) => {
          let failed = (data.failedList || []).length;
          this.$Message(`成功删除 ${data.successCount} 条${failed ? `，${failed} 条删除失败` : ''}`);
          this.loadList();
        });
      });
    },
    downloadTemplate() {
      this.$api.tripartite.data.template(this.definitionId).then(res => {
        this.downloadBlob(res.data, `${this.definition.name || '数据'}-导入模板.xlsx`);
      });
    },
    importFileChange() {
      if (this.$refs.importFile.files.length) {
        let formData = new FormData();
        formData.append('file', this.$refs.importFile.files[0]);
        this.loading = true;
        this.$api.tripartite.data.import(this.definitionId, formData).then(({data}) => {
          this.importResult = data;
          if (data.successCount > 0) {
            this.loadList();
          }
        }).finally(() => {
          this.loading = false;
        });
        this.$refs.importFile.value = '';
      }
    },
    exportSelected() {
      let ids = this.checkedList.map(d => d.id);
      if (!ids.length) {
        this.$Message.error('请勾选需要导出的记录！');
        return;
      }
      this.$api.tripartite.data.download(this.definitionId, {ids}).then(res => {
        this.downloadBlob(res.data, `${this.definition.name || '数据'}-数据.xlsx`);
      });
    },
    exportAll() {
      this.$api.tripartite.data.download(this.definitionId, {filters: this.buildFilters()}).then(res => {
        this.downloadBlob(res.data, `${this.definition.name || '数据'}-数据.xlsx`);
      });
    },
    downloadBlob(blob, filename) {
      let url = window.URL.createObjectURL(new Blob([blob]));
      let link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    openVoucher(data) {
      this.$router.push({name: 'VoucherForm', params: {voucherId: data.voucherId}});
    },
    // ==================== 模板设置 ====================
    openTemplates() {
      this.showTemplates = true;
      this.loadTemplates();
    },
    loadTemplates() {
      this.$api.tripartite.definition.template.list(this.definitionId).then(({data}) => {
        this.templates = data || [];
      });
    },
    tplAdd() {
      this.tplForm = this.emptyTplForm();
      if (this.dataFields.length) {
        let dateField = this.dataFields.find(f => f.period) || this.dataFields.find(f => f.fieldType === 'DATE');
        this.tplForm.dateFieldName = dateField ? dateField.fieldName : null;
        let numField = this.numberFields[0];
        this.tplForm.items[0].fieldName = this.dataFields[0].fieldName;
        this.tplForm.items[0].amountFieldName = numField ? numField.fieldName : null;
      }
      this.showTplForm = true;
    },
    tplCopy(data) {
      let tpl = this.toTplForm(data);
      tpl.tid = null;
      this.tplForm = tpl;
      this.showTplForm = true;
    },
    tplEdit(data) {
      this.tplForm = this.toTplForm(data);
      this.showTplForm = true;
    },
    toTplForm(data) {
      return {
        tid: data.tid || data.id,
        voucherWord: data.voucherWord || '记',
        dateFieldName: data.dateFieldName,
        summaryFieldNames: data.summaryFieldNames || [],
        rules: (data.rules || []).map(r => ({
          logical: r.logical || 'AND',
          fieldName: r.fieldName,
          matchValuesText: (r.matchValues || []).join(',')
        })),
        items: (data.items || []).map(item => ({
          itemType: item.itemType || 'FINANCIAL_SUBJECT',
          fieldName: item.fieldName || null,
          matchValuesText: (item.matchValues || []).join(','),
          amountFieldName: item.amountFieldName || null,
          amountRatio: item.amountRatio === null || item.amountRatio === undefined ? 100 : item.amountRatio,
          subjectId: item.subjectId || null,
          autoEqual: !!item.autoEqual,
          direction: item.direction || '借',
          quantityFieldName: item.quantityFieldName || null,
          unitFieldName: item.unitFieldName || null,
          auxiliaryFieldMappings: item.auxiliaryFieldMappings || []
        }))
      };
    },
    addTplItem() {
      this.tplForm.items.push({
        itemType: 'FINANCIAL_SUBJECT',
        fieldName: null,
        matchValuesText: '',
        amountFieldName: null,
        amountRatio: 100,
        subjectId: null,
        autoEqual: false,
        direction: '借',
        quantityFieldName: null,
        unitFieldName: null,
        auxiliaryFieldMappings: []
      });
    },
    editAuxMappings(item) {
      this.auxMappingItem = item;
      this.auxMappings = JSON.parse(JSON.stringify(item.auxiliaryFieldMappings || []));
      this.showAuxMapping = true;
    },
    saveAuxMappings() {
      this.auxMappingItem.auxiliaryFieldMappings = this.auxMappings.filter(m => m.categoryTypeId && m.fieldName);
      this.showAuxMapping = false;
    },
    tplSave() {
      if (!this.tplForm.voucherWord) {
        this.$Message.error('请选择凭证字！');
        return;
      }
      if (!this.tplForm.dateFieldName) {
        this.$Message.error('请选择凭证日期列！');
        return;
      }
      if (!this.tplForm.items.length) {
        this.$Message.error('至少保留两行明细，一个数据科目和一个记账科目');
        return;
      }
      let hasDataSubject = this.tplForm.items.some(i => i.itemType === 'DATA_SUBJECT');
      let hasFinSubject = this.tplForm.items.some(i => i.itemType === 'FINANCIAL_SUBJECT');
      if (!hasDataSubject || !hasFinSubject) {
        this.$Message.error('必须要有数据科目和记账科目');
        return;
      }
      if (this.tplForm.items.filter(i => i.autoEqual).length > 1) {
        this.$Message.error('只能有一个自动平衡行');
        return;
      }
      let hasDebit = this.tplForm.items.some(i => i.direction === '借');
      let hasCredit = this.tplForm.items.some(i => i.direction === '贷');
      if (!hasDebit || !hasCredit) {
        this.$Message.error('必须要有借方和贷方两个方向');
        return;
      }
      for (let item of this.tplForm.items) {
        if (!item.subjectId) {
          this.$Message.error('分录规则存在未选择科目的行！');
          return;
        }
        if (item.itemType === 'DATA_SUBJECT' && !item.fieldName) {
          this.$Message.error('数据科目行必须选择匹配列！');
          return;
        }
        if (!item.autoEqual && !item.amountFieldName) {
          this.$Message.error('非自动平衡行必须选择金额字段！');
          return;
        }
      }
      this.saving = true;
      let params = {
        tid: this.tplForm.tid,
        voucherWord: this.tplForm.voucherWord,
        dateFieldName: this.tplForm.dateFieldName,
        summaryFieldNames: this.tplForm.summaryFieldNames,
        rules: this.tplForm.rules.filter(r => r.fieldName).map(r => ({
          logical: r.logical || 'AND',
          fieldName: r.fieldName,
          matchValues: (r.matchValuesText || '').split(/[,，]/).map(v => v.trim()).filter(v => v !== '')
        })),
        items: this.tplForm.items.map(item => ({
          itemType: item.itemType,
          fieldName: item.fieldName,
          matchValues: (item.matchValuesText || '').split(/[,，]/).map(v => v.trim()).filter(v => v !== ''),
          amountFieldName: item.amountFieldName,
          amountRatio: item.amountRatio === null || item.amountRatio === undefined ? 100 : item.amountRatio,
          subjectId: item.subjectId,
          autoEqual: !!item.autoEqual,
          direction: item.direction,
          quantityFieldName: item.quantityFieldName,
          unitFieldName: item.unitFieldName,
          auxiliaryFieldMappings: item.auxiliaryFieldMappings || []
        }))
      };
      this.$api.tripartite.definition.template.save(this.definitionId, params).then(() => {
        this.$Message('模板保存成功~');
        this.showTplForm = false;
        this.loadTemplates();
      }).finally(() => {
        this.saving = false;
      });
    },
    tplDelete(data) {
      this.$Confirm('确认删除该模板？').then(() => {
        this.$api.tripartite.definition.template.delete(this.definitionId, data.tid || data.id).then(() => {
          this.$Message('删除成功~');
          this.loadTemplates();
        });
      });
    },
    // ==================== 生成凭证 ====================
    loadCategoryDetails(categoryTypeId) {
      if (this.categoryDetailsCache[categoryTypeId]) {
        return Promise.resolve(this.categoryDetailsCache[categoryTypeId]);
      }
      return this.$api.setting.accountingCategoryDetails.list(categoryTypeId).then(({data}) => {
        this.categoryDetailsCache[categoryTypeId] = data || [];
        return this.categoryDetailsCache[categoryTypeId];
      });
    },
    matchRules(record, rules) {
      if (!rules || !rules.length) {
        return true;
      }
      let result = null;
      rules.forEach(rule => {
        let value = record[rule.fieldName];
        let hit = !rule.matchValues || !rule.matchValues.length || rule.matchValues.indexOf(String(value)) > -1;
        if (result === null) {
          result = hit;
        } else if (rule.logical === 'OR') {
          result = result || hit;
        } else {
          result = result && hit;
        }
      });
      return result === null ? true : result;
    },
    buildVoucher(record, recordId, template) {
      let voucher = {
        voucherDate: this.genOptions.voucherDate ? moment(this.genOptions.voucherDate).format('YYYY-MM-DD') : record[template.dateFieldName],
        word: this.genOptions.voucherWord || template.voucherWord,
        details: [],
        tripartiteIds: [recordId]
      };
      let summary = (template.summaryFieldNames || []).map(fn => record[fn]).filter(v => v !== null && v !== undefined && v !== '').join(' ');
      let autoEqualDetail = null;
      template.items.forEach((item) => {
        if (item.itemType === 'DATA_SUBJECT') {
          let value = record[item.fieldName];
          if (item.matchValues && item.matchValues.length && item.matchValues.indexOf(String(value)) < 0) {
            return;
          }
        }
        let detail = {
          summary,
          subjectId: item.subjectId,
          debitAmount: null,
          creditAmount: null,
          num: null,
          price: null,
          auxiliaryTitle: '',
          auxiliary: []
        };
        if (item.autoEqual) {
          autoEqualDetail = detail;
          detail._autoEqual = true;
          detail._direction = item.direction;
        } else {
          let amount = parseFloat(record[item.amountFieldName]);
          if (isNaN(amount)) {
            amount = 0;
          }
          amount = Math.round(amount * (item.amountRatio === null || item.amountRatio === undefined ? 100 : item.amountRatio)) / 100;
          amount = Math.round(amount * 100) / 100;
          if (item.direction === '借') {
            detail.debitAmount = amount;
          } else {
            detail.creditAmount = amount;
          }
        }
        if (item.quantityFieldName && record[item.quantityFieldName] !== null && record[item.quantityFieldName] !== undefined && record[item.quantityFieldName] !== '') {
          let qty = parseFloat(record[item.quantityFieldName]);
          if (!isNaN(qty) && qty !== 0) {
            detail.num = qty;
            let amount = detail.debitAmount || detail.creditAmount || 0;
            detail.price = Math.round((amount / qty) * 1000000) / 1000000;
          }
        }
        // 辅助核算
        if (item.auxiliaryFieldMappings && item.auxiliaryFieldMappings.length) {
          let titles = [];
          item.auxiliaryFieldMappings.forEach(m => {
            let value = record[m.fieldName];
            if (value === null || value === undefined || value === '') {
              return;
            }
            let details = this.categoryDetailsCache[m.categoryTypeId] || [];
            let hit = details.find(cd => cd.name === String(value) || cd.code === String(value));
            if (hit) {
              detail.auxiliary.push({id: hit.id, accountingCategoryId: m.categoryTypeId});
              titles.push(hit.name);
            } else {
              detail._auxMiss = (detail._auxMiss || '') + `辅助核算“${value}”不存在 `;
            }
          });
          detail.auxiliaryTitle = titles.join('/');
        }
        voucher.details.push(detail);
      });
      if (voucher.details.length < 2) {
        throw new Error('至少保留两行明细');
      }
      // 自动平衡行
      if (autoEqualDetail) {
        let debit = 0, credit = 0;
        voucher.details.forEach(d => {
          debit += d.debitAmount || 0;
          credit += d.creditAmount || 0;
        });
        let diff = Math.round((debit - credit) * 100) / 100;
        if (autoEqualDetail._direction === '借') {
          if (-diff < 0) {
            throw new Error('自动平衡行计算金额为负，请检查金额配置');
          }
          autoEqualDetail.debitAmount = -diff;
        } else {
          if (diff < 0) {
            throw new Error('自动平衡行计算金额为负，请检查金额配置');
          }
          autoEqualDetail.creditAmount = diff;
        }
      }
      // 合并分录
      if (this.genOptions.merge) {
        let mergeDebit = this.genOptions.mergeTypes.indexOf('mergeDebit') > -1;
        let mergeCredit = this.genOptions.mergeTypes.indexOf('mergeCredit') > -1;
        let merged = [];
        voucher.details.forEach(d => {
          let direction = d.debitAmount !== null && d.debitAmount !== undefined && d.debitAmount !== '' && d.debitAmount !== 0 ? '借' : '贷';
          let canMerge = (direction === '借' && mergeDebit) || (direction === '贷' && mergeCredit);
          let target = canMerge ? merged.find(m => m.subjectId === d.subjectId && ((direction === '借' && m.debitAmount !== null) || (direction === '贷' && m.creditAmount !== null))) : null;
          if (target) {
            if (direction === '借') {
              target.debitAmount = Math.round(((target.debitAmount || 0) + (d.debitAmount || 0)) * 100) / 100;
            } else {
              target.creditAmount = Math.round(((target.creditAmount || 0) + (d.creditAmount || 0)) * 100) / 100;
            }
          } else {
            merged.push(d);
          }
        });
        voucher.details = merged;
      }
      // 校验
      if (voucher.details.length < 2) {
        throw new Error('至少保留两行明细');
      }
      let hasDebit = voucher.details.some(d => (d.debitAmount || 0) > 0);
      let hasCredit = voucher.details.some(d => (d.creditAmount || 0) > 0);
      if (!hasDebit || !hasCredit) {
        throw new Error('必须要有借方和贷方两个方向');
      }
      let debitSum = 0, creditSum = 0;
      voucher.details.forEach(d => {
        debitSum += d.debitAmount || 0;
        creditSum += d.creditAmount || 0;
      });
      if (debitSum === 0 && creditSum === 0) {
        throw new Error('请检查凭证明细，明细借方金额和贷方金额不能全部为0');
      }
      if (Math.abs(debitSum - creditSum) > 0.001) {
        throw new Error('凭证借贷不平衡');
      }
      voucher.details.forEach(d => {
        if (d._auxMiss) {
          throw new Error(d._auxMiss);
        }
      });
      return voucher;
    },
    openGenerate() {
      let records = this.checkedList;
      if (!records.length) {
        this.$Message.error('请勾选未生成凭证的记录！');
        return;
      }
      this.$api.tripartite.definition.template.list(this.definitionId).then(({data}) => {
        let templates = data || [];
        if (!templates.length) {
          this.$Message.error('请先在"模板设置"中创建凭证模板！');
          return;
        }
        // 预加载辅助核算明细
        let categoryIds = [];
        templates.forEach(t => (t.items || []).forEach(item => (item.auxiliaryFieldMappings || []).forEach(m => {
          if (categoryIds.indexOf(m.categoryTypeId) < 0) {
            categoryIds.push(m.categoryTypeId);
          }
        })));
        Promise.all(categoryIds.map(id => this.loadCategoryDetails(id))).then(() => {
          this.previewVouchers = records.map(r => {
            let record = r.data || {};
            let template = templates.find(t => this.matchRules(record, t.rules));
            let label = this.dataFields.length ? record[this.dataFields[0].fieldName] : ('#' + r.id);
            if (!template) {
              return {key: r.id, recordId: r.id, recordLabel: label, error: '没有匹配的凭证模板', voucher: {details: []}};
            }
            try {
              let voucher = this.buildVoucher(record, r.id, template);
              return {key: r.id, recordId: r.id, recordLabel: label, error: null, voucher};
            } catch (e) {
              return {key: r.id, recordId: r.id, recordLabel: label, error: e.message, voucher: {details: []}};
            }
          });
          this.showGenerate = true;
        });
      });
    },
    submitGenerate() {
      let vouchers = this.previewVouchers.filter(pv => !pv.error).map(pv => {
        let v = pv.voucher;
        return {
          voucherDate: v.voucherDate,
          word: v.word,
          tripartiteIds: v.tripartiteIds,
          details: v.details.map(d => ({
            summary: d.summary,
            subjectId: d.subjectId,
            debitAmount: d.debitAmount || null,
            creditAmount: d.creditAmount || null,
            num: d.num || null,
            price: d.price || null,
            auxiliaryTitle: d.auxiliaryTitle || '',
            auxiliary: d.auxiliary || []
          }))
        };
      });
      if (!vouchers.length) {
        this.$Message.error('没有可生成的凭证，请检查错误记录！');
        return;
      }
      // 提交前复核平衡
      for (let v of vouchers) {
        let debit = 0, credit = 0;
        v.details.forEach(d => {
          debit += d.debitAmount || 0;
          credit += d.creditAmount || 0;
        });
        if (debit === 0 && credit === 0) {
          this.$Message.error('请检查凭证明细，明细借方金额和贷方金额不能全部为0');
          return;
        }
        if (Math.abs(debit - credit) > 0.001) {
          this.$Message.error('存在借贷不平衡的凭证，请调整后再提交！');
          return;
        }
      }
      this.generating = true;
      this.$api.tripartite.data.generateVoucher(this.definitionId, vouchers).then(({data}) => {
        let errors = data || {};
        let errorKeys = Object.keys(errors);
        if (errorKeys.length) {
          errorKeys.forEach(key => {
            let pv = this.previewVouchers.find(p => String(p.recordId) === String(key));
            if (pv) {
              pv.error = errors[key];
            }
          });
          this.$Message.error('部分记录凭证生成失败，请检查~');
          this.loadList();
        } else {
          this.$Message('凭证生成成功~');
          this.showGenerate = false;
          this.loadList();
        }
      }).finally(() => {
        this.generating = false;
      });
    }
  },
  mounted() {
    this.loadDefinition().then(() => {
      this.loadList();
    });
    this.$api.setting.voucherWord.list().then(({data}) => {
      this.voucherWords = data || [];
    });
    this.$api.setting.subject.allList().then(({data}) => {
      this.subjects = data || [];
    });
    this.$api.setting.accountingCategory.list().then(({data}) => {
      this.categories = data || [];
    });
  }
}
</script>

<style lang="less" scoped>
.tpl-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;

  th, td {
    border: 1px solid #e8e8e8;
    padding: 4px 6px;
    font-size: 12px;
  }

  th {
    background: #fafafa;
    font-weight: normal;
    white-space: nowrap;
  }

  input[type="text"], input[type="number"] {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
  }

  .tpl-select {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
  }
}

.tpl-block {
  width: 100%;
}

.pointer {
  cursor: pointer;
}

.preview-voucher {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 10px;

  .preview-head {
    margin-bottom: 6px;
  }

  &.preview-error {
    border-color: #ff4d4f;
    background: #fff1f0;
  }
}
</style>
